module.exports = __webpack_public_path__ + "img/yoshimitsu.92df0abe.jpg";